// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gridDialog .el-dialog__body {\n  padding: 10px 0px 0px 10px;\n  color: #606266;\n  font-size: 14px;\n  word-break: break-all;\n}\n.gridDialog .el-pagination {\n  margin-top: 5px;\n  margin-bottom: 4px;\n}", ""]);
// Exports
module.exports = exports;
